import { Workbox } from 'workbox-window'

export const setupWorkbox = () => {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            window.regiweb = window.regiweb || {}
            window.regiweb.wb = new Workbox('/service-worker.js')
            window.regiweb.wb.addEventListener('installed', event => {
                console.log('installed...')
                if (event.isUpdate) {
                    store.commit('toggleRefresh')
                    // if (confirm(`New content is available!. Click OK to refresh`)) {
                    //     window.location.reload();
                    // }
                }
            })

            window.regiweb.wb.register()
        })
    }
}
